import IPaymentRequiredData from '@/interfaces/iPaymentRequiredData';
import IPaymentProcessor from './iPaymentProcessor';
import NoPaymentSessionDataFoundError from '@/entities/errors/noPaymentSessionDataFoundError';
import { useAuthenticationStore } from '../../stores/authenticationStore';
import { useUserStore } from '../../stores/userStore';

export default class UserPaymentProcessor implements IPaymentProcessor {

    message = 'Please wait while your account is being prepared...';

    constructor(private paymentData: IPaymentRequiredData) {}

    async process() {
        const userToken: string = useAuthenticationStore().token;

        window.sessionStorage.removeItem(this.paymentData.vendibleId);

        if (!userToken) {
            throw new NoPaymentSessionDataFoundError();
        }

        await useUserStore().createUser({
            method: this.paymentData.source.method,
            args: this.paymentData.source.args
        });
    }
}
